import React, { FunctionComponent } from "react"
import "./TaskManagerNoTasks.css"

interface TaskManagerNoTasksProps {
    taskType: string
}

const TaskManagerNoTasks: FunctionComponent<TaskManagerNoTasksProps> = (props) => {
    return (
        <div className="TaskManagerNoTasks">
            <div className="TaskManagerNoTasksCentered">
                <span id="task-manager-no-tasks-bottom" className="material-icons">task</span>
                <span id="task-manager-no-tasks-top" className="material-icons">block</span>
                {<p id="task-manager-no-tasks-text">{`No ${props.taskType}`}</p>}
            </div>
        </div>
    )
}

export default TaskManagerNoTasks